import { render } from "./zyjReviewListCo.vue?vue&type=template&id=47514f8e&scoped=true"
import script from "./zyjReviewListCo.vue?vue&type=script&lang=js"
export * from "./zyjReviewListCo.vue?vue&type=script&lang=js"

import "./zyjReviewListCo.vue?vue&type=style&index=0&id=47514f8e&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47514f8e"]])

export default __exports__